import React from 'react';
import cn from 'clsx';
import PropTypes from 'prop-types';

import styles from './skeleton-element.scss';

function SkeletonElement(props) {
  const { className } = props;

  return <div className={cn(styles['default'], className)} />;
}

SkeletonElement.propTypes = {
  className: PropTypes.string
};

export default SkeletonElement;
